export default __webpack_public_path__ + "static/media/crm.6a092910.svg";